import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { orderApi } from '../api/services';
import { StatusBadge, useOrderHub } from '../hooks/useOrderHub';

export default function OrdersPage() {
  const { data, refetch } = useQuery({
    queryKey: ['my-orders'],
    queryFn: () => orderApi.getMyOrders().then((r) => r.data),
  });

  useOrderHub({
    'order-status-changed': () => refetch(),
    'order-cancelled': () => refetch(),
  });

  const items = data?.items ?? [];
  return (
    <div className="container" style={{ paddingTop: 32, paddingBottom: 48 }}>
      <h1 style={{ marginBottom: 24 }}>Siparişlerim</h1>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {items.map((o: any) => (
          <Link key={o.id} to={`/orders/${o.id}`} className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}>
            <div>
              <p style={{ fontFamily: 'monospace', fontWeight: 700 }}>{o.orderNumber}</p>
              <p className="text-muted" style={{ fontSize: '0.85rem' }}>
                {new Date(o.createdAt).toLocaleString('tr-TR')} · {o.itemCount} ürün
              </p>
            </div>
            <div style={{ textAlign: 'right' }}>
              <p style={{ fontWeight: 700 }}>{Number(o.totalAmount).toFixed(2)} ₺</p>
              <StatusBadge status={o.status} />
            </div>
          </Link>
        ))}
        {items.length === 0 && <p className="text-muted text-center" style={{ padding: 48 }}>Henüz siparişiniz yok.</p>}
      </div>
    </div>
  );
}
